export class GcpPrincipalInput {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "serviceAccountEmail",
            "baseName": "serviceAccountEmail",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GcpPrincipalInput.attributeTypeMap;
    }
    constructor() {
    }
}
